import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import CommentCardWithModal from '../../../../../components/ui/CommentCardWithModal/CommentCardWithModal';
import useHouseComment from '../../../../../queries/useHouseComment';
import changeHouseComment from '../../../../../requests/changeHouseComment';
import styles from '../HouseInfo.module.scss';

const HouseComment = ({ address }) => {
  const params = useParams();

  const queryClient = useQueryClient();

  const houseId = Number(params.pageId);

  const { data: houseComment, isFetching: isHouseCommentFetching } =
    useHouseComment(houseId, { staleTime: Infinity });

  const handleSubmit = async (fieldValues) => {
    const res = await changeHouseComment(
      houseId,
      fieldValues,
      Boolean(houseComment.comment)
    );

    if (res.result === 'Ok') {
      queryClient.setQueryData([`houseComment`, houseId], fieldValues);
    }
  };

  return (
    <CommentCardWithModal
      comment={houseComment?.comment}
      loading={isHouseCommentFetching}
      address={address}
      onSubmit={handleSubmit}
    />
  );
};

export default HouseComment;
